import { useCallback } from "react";
import { KanjiMemoryProgress } from "../utils/kanjiMemoryStorage";
import { useDeviceProgress } from "./useDeviceProgress";
export function useKanjiMemoryProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<KanjiMemoryProgress>("kanjiMemory", true);
    const classify = useCallback((key: string, value: string) => { void update({ kind: "set", key, value }); }, [update]);
    const reset = useCallback(() => { void update({ kind: "reset" }); }, [update]);
    return { progress, classify, reset, syncStatus };
}
